import { ServicesState } from "../types/ServicesState";
import { ServiceName } from "./types";

export const state: ServicesState = {
    validServiceNames: [
        ServiceName.supportChat,
        ServiceName.eventsManagement,
        ServiceName.meetings,
        ServiceName.catalog,
        ServiceName.tabs,
        ServiceName.googleAnalytics,
        ServiceName.webClientFooter,
        ServiceName.webClientPageParams,
        ServiceName.userProfile,
        ServiceName.ticketSystem,
        ServiceName.messenger,
        ServiceName.favoriteSessions,
        ServiceName.notifications,
        ServiceName.ratings,
        ServiceName.anonymousUsing
    ],
    serviceParams: {
        supportChat: {
            isEnabled: {
                defaultValue: false,
            },
            supporterUserId: {}
        }
    },
    services: {},
    updateTime: null,
    freshChat: null
}
